var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.attendance.rescheduled_to
      ? _c("div", { staticClass: "caption soli-grey" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                `Rescheduled: ${_vm.globalMomentDateAtTimeDots(
                  _vm.attendance.rescheduled_to
                )}`
              ) +
              "\n    "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.attendance.reschedule_minutes > 0
      ? _c("div", { staticClass: "caption soli-grey" }, [
          _vm._v(
            "\n        " +
              _vm._s(`${_vm.attendance.reschedule_minutes} min remaining`) +
              "\n    "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.attendance.reschedule_pass
      ? _c("div", { staticClass: "caption soli-grey" }, [
          _vm._v("\n        1 visit remaining\n    "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }